import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { View, Platform } from 'react-native'
import styled from 'styled-components/native'

import WarningAlert from '../Molecules/WarningAlert'
import CEOTransferAlert from '../Organisms/CEOTransferAlert'
import Sidebar from '../Organisms/Sidebar'
import Header from '../Organisms/Header'
import AppNav from '../../navigators/main'
import SplashScreen from './SplashScreen'
import WaitingRoom from './WaitingRoom'

import NavigationService from '../../services/navigation'

import theme from '../../styles/theme'

const { statusBarHeight } = theme

const Container = styled(View)`
  flex: 1;
  flex-direction: row;
  margin-top: ${statusBarHeight ? `${statusBarHeight}px` : 0};
`

const MainContainer = styled(View)`
  flex: 1;
`

class Main extends PureComponent {
  render () {
    return (
      <Container>
        {this.props.gameStarted && (
          <>
            <Sidebar />
            <MainContainer>
              <Header />
              <AppNav ref={navigatorRef => {
                NavigationService.setTopLevelNavigator(navigatorRef)
              }}
              />
            </MainContainer>
          </>)}
        {Platform.OS !== 'web' ? <SplashScreen /> : <WaitingRoom />}
        <WarningAlert />
        <CEOTransferAlert />
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  gameStarted: state.game.currentRound > 0
})

export default connect(mapStateToProps, null)(Main)
